const DEBUG = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const MAIN_SITE = process.env.NODE_ENV === "development" ? "http://devhost:8082" : `https://www.lipsurf.com`;
const DEVELOPER_DOCS_SITE = `https://docs.lipsurf.com`;
const PRICING_URL = `${MAIN_SITE}/pricing/`;
const PLAN_SETTINGS_URL = `${MAIN_SITE}/settings/plan/`;
const LOGIN_URL = `${MAIN_SITE}/login/`;
const UPDATES_URL = `${MAIN_SITE}/updates/`;
const CONTACT_URL = `${MAIN_SITE}/contact/`;
const UNINSTALL_URL = `${MAIN_SITE}/uninstall/`;
const PRIVACY_URL = `${MAIN_SITE}/privacy/`;
const TOS_URL = `${MAIN_SITE}/tos/`;
const HELP_URL = `https://help.lipsurf.com`;
const FORUM_URL = process.env.NODE_ENV === "development" ? "http://localhost:4200" : "https://discuss.lipsurf.com";
const I18N_DOCS_URL = `${HELP_URL}/configuration/adding-languages.html#adding-languages`;
const API_BASE_URL = process.env.NODE_ENV === "development" ? "http://devhost:5001/lipsurf-216216/us-central1" : "https://www.lipsurf.com/api";
const TUTORIAL_PATH = `/tutorial.html`;
const NO_COLLISION_UNIQUE_ATTR = "rnh290318";
const XFRAME_UNIQUE_ID_ATTR_NAME = `data-${NO_COLLISION_UNIQUE_ATTR}-id`;
const HUD_ID = `${NO_COLLISION_UNIQUE_ATTR}-hud`;
const OBS_HUD_ID = `${NO_COLLISION_UNIQUE_ATTR}-hud-obs`;
const DOBS_HUD_ID = `${NO_COLLISION_UNIQUE_ATTR}-hud-dobs`;
const ON_ICON = "/assets/icon-on.png";
const PLAIN_ICON = "/assets/icon-128.png";
const OFF_ICON = "/assets/icon-off.png";
const ORDINAL_CMD_DELAY = 500;
const WILDCARD_CMD_DELAY = 900;
const PARTIAL_MATCH_DELAY = 700;
const DYN_CMD_DEFAULT_PRIORITY = 1e4;
const CONFIDENCE_THRESHOLD = 0;
const POSSIBLE_LANGS = [
  "en-AU",
  "en-CA",
  "en-IE",
  "en-IN",
  "en-NZ",
  "en-PH",
  "en-ZA",
  "en-GB",
  "en-US",
  "ja",
  "ru-RU",
  "uk",
  "es-ES",
  "fr-FR",
  "pt-PT",
  "de-DE",
  "fi",
  "nl-NL"
];
const LANG_CODE_TO_NICE = {
  en: "English",
  es: "Español Spanish BETA",
  "es-ES": "Español Spanish BETA",
  ja: "日本語 Japanese BETA",
  uk: "Український Ukrainian BETA",
  ru: "Русский Russian BETA",
  "ru-RU": "Русский Russian BETA",
  fr: "Français French",
  "fr-FR": "Français French",
  de: "Deutsche German (Duolingo only)",
  "de-DE": "Deutsche German (Duolingo only)",
  pt: "Português Portuguese (Duolingo only)",
  "pt-PT": "Português Portuguese (Duolingo only)",
  nl: "Nederlands Dutch (Duolingo only)",
  "nl-NL": "Nederlands Dutch (Duolingo only)",
  fi: "Suomi Finnish (WaniKani only)",
  "en-AU": "English (Australia)",
  "en-CA": "English (Canada)",
  "en-IE": "English (Ireland)",
  "en-IN": "English (India)",
  "en-NZ": "English (New Zealand)",
  "en-PH": "English (Philippines)",
  "en-ZA": "English (South Africa)",
  "en-GB": "English (UK)",
  "en-US": "English (US)"
};
const LANG_CODE_TO_COUNTRY = {
  ja: "jp",
  uk: "ua"
};
const POSSIBLE_LANGS_TO_NICE = POSSIBLE_LANGS.reduce((memo, lang) => {
  memo[lang] = LANG_CODE_TO_NICE[lang];
  return memo;
}, {});
const BUGSNAG_API_KEY = process.env.VITE_BUGSNAG_API_KEY;
const POSTHOG_KEY = process.env.VITE_POSTHOG_KEY;
const STRIPE_API_KEY = process.env.VITE_STRIPE_API_KEY;
const PING_LIVE_TEXT_COUNT = 15;
const FREE_PLAN = 0;
const PREMIUM_PLAN = 20;
const PLAN_TO_NICE = {
  [FREE_PLAN]: "Free",
  10: "Premium",
  [PREMIUM_PLAN]: "Premium"
};
const TERMS = ["yearly", "monthly"];
const PLANS = [FREE_PLAN, PREMIUM_PLAN];
const FREE_DAILY_CMD_LIMIT = Number(process.env.FREE_DAILY_CMD_LIMIT) || 200;
const isPremium = (p) => p > FREE_PLAN;
const ANNO_BLINK_TIME = 3e3;
const FUZZY_SIMILARITY_THRESHOLD = 0.099;
const PLUGIN_SPLIT_SEQ = "\vLS-SPLIT";
const SPECIAL_TEST_PAGE_REGX = /^http:\/\/localhost:/;
const UPGRADE_MSG = "";
const MAX_IFRAME_RESP_TIME = 1500;
const EXT_ID = process.env.EXT_ID || (process.env.BROWSER === "safari" ? "11C90F6F-8158-43E7-B45D-61FBD96C7288" : "lnnmjmalakahagblkkcnjkoaihlfglon");
const EXT_RESOURCES_PREFIX = process.env.BROWSER === "safari" ? `safari-web-extension://${EXT_ID}` : `chrome-extension://${EXT_ID}`;
var SharedContexts = /* @__PURE__ */ ((SharedContexts2) => {
  SharedContexts2["Normal"] = "Normal";
  SharedContexts2["Tag"] = "Tag";
  return SharedContexts2;
})(SharedContexts || {});
const CUSTOM_HOMOSYNS_PLUGIN_ID = "Custom";
export {
  ANNO_BLINK_TIME,
  API_BASE_URL,
  BUGSNAG_API_KEY,
  CONFIDENCE_THRESHOLD,
  CONTACT_URL,
  CUSTOM_HOMOSYNS_PLUGIN_ID,
  DEBUG,
  DEVELOPER_DOCS_SITE,
  DOBS_HUD_ID,
  DYN_CMD_DEFAULT_PRIORITY,
  EXT_ID,
  EXT_RESOURCES_PREFIX,
  FORUM_URL,
  FREE_DAILY_CMD_LIMIT,
  FREE_PLAN,
  FUZZY_SIMILARITY_THRESHOLD,
  HELP_URL,
  HUD_ID,
  I18N_DOCS_URL,
  LANG_CODE_TO_COUNTRY,
  LANG_CODE_TO_NICE,
  LOGIN_URL,
  MAIN_SITE,
  MAX_IFRAME_RESP_TIME,
  NO_COLLISION_UNIQUE_ATTR,
  OBS_HUD_ID,
  OFF_ICON,
  ON_ICON,
  ORDINAL_CMD_DELAY,
  PARTIAL_MATCH_DELAY,
  PING_LIVE_TEXT_COUNT,
  PLAIN_ICON,
  PLANS,
  PLAN_SETTINGS_URL,
  PLAN_TO_NICE,
  PLUGIN_SPLIT_SEQ,
  POSSIBLE_LANGS,
  POSSIBLE_LANGS_TO_NICE,
  POSTHOG_KEY,
  PREMIUM_PLAN,
  PRICING_URL,
  PRIVACY_URL,
  SPECIAL_TEST_PAGE_REGX,
  STRIPE_API_KEY,
  SharedContexts,
  TERMS,
  TOS_URL,
  TUTORIAL_PATH,
  UNINSTALL_URL,
  UPDATES_URL,
  UPGRADE_MSG,
  WILDCARD_CMD_DELAY,
  XFRAME_UNIQUE_ID_ATTR_NAME,
  isPremium
};
